import { Theme, createStyles } from '@material-ui/core';
import sectionPageBaseStyle from '../commonStyles/sectionPageBase.style';
import { getFiltersStylesWithTheme } from '../filtersDrawer/filterBadge.style';
export default createStyles((theme: Theme) => ({
  ...sectionPageBaseStyle,
  ...getFiltersStylesWithTheme(theme)
}));
